import React from "react";
import { useTranslation } from "react-i18next";

const SaveAndContinueUserMessage = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <>
      {props.messageType === "save and continue" && (
        <p className="alert alert-warning text-start">
          {t("messages.saveAndContinueWarning")}
        </p>
      )}
      {props.messageType === "save" && (
        <p className="alert alert-warning text-start">
          {t("messages.saveWarning", { task: props.task })}
        </p>
      )}
    </>
  );
};

export default SaveAndContinueUserMessage;
